import React from 'react';
import { Heart, Instagram, Facebook, Mail } from 'lucide-react';
import { companyInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer style={{ background: 'var(--bg-secondary)', color: 'var(--text-primary)', padding: '60px 0 24px', borderTop: '2px solid var(--gold-primary)' }}>
      <div className="container">
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '40px',
          marginBottom: '60px'
        }}>
          {/* Brand Column */}
          <div>
            <img 
              src={companyInfo.logo}
              alt={companyInfo.name}
              style={{ 
                height: '80px',
                width: 'auto',
                marginBottom: '20px'
              }}
            />
            <p className="body-regular" style={{ color: 'var(--text-secondary)', lineHeight: '1.7', marginBottom: '20px' }}>
              {companyInfo.tagline}
            </p>
            <div style={{ display: 'flex', gap: '16px' }}>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  width: '40px',
                  height: '40px',
                  background: 'var(--gold-subtle)',
                  border: '1px solid var(--gold-primary)',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'all 0.2s ease'
                }}
                className="social-icon"
              >
                <Instagram size={20} color="var(--gold-primary)" />
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  width: '40px',
                  height: '40px',
                  background: 'var(--gold-subtle)',
                  border: '1px solid var(--gold-primary)',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'all 0.2s ease'
                }}
                className="social-icon"
              >
                <Facebook size={20} color="var(--gold-primary)" />
              </a>
              <a
                href={`mailto:${companyInfo.email}`}
                style={{
                  width: '40px',
                  height: '40px',
                  background: 'var(--gold-subtle)',
                  border: '1px solid var(--gold-primary)',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'all 0.2s ease'
                }}
                className="social-icon"
              >
                <Mail size={20} color="var(--gold-primary)" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="heading-3" style={{ marginBottom: '20px', color: 'var(--gold-primary)' }}>
              Link Cepat
            </h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              {['Tentang Kami', 'Layanan', 'Portfolio', 'Testimoni', 'Kontak'].map((item) => (
                <li key={item} style={{ marginBottom: '12px' }}>
                  <button
                    onClick={() => {
                      const id = item.toLowerCase().replace(' ', '-');
                      const element = document.getElementById(id === 'tentang-kami' ? 'tentang' : id);
                      if (element) element.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="body-regular"
                    style={{
                      background: 'none',
                      border: 'none',
                      color: 'var(--text-secondary)',
                      cursor: 'pointer',
                      padding: 0,
                      textAlign: 'left',
                      transition: 'color 0.2s ease'
                    }}
                  >
                    {item}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="heading-3" style={{ marginBottom: '20px', color: 'var(--gold-primary)' }}>
              Layanan
            </h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              {['Wedding Organizer', 'Dekorasi & Styling', 'Catering Premium', 'Photography', 'Makeup & Busana'].map((service) => (
                <li key={service} style={{ marginBottom: '12px' }}>
                  <span className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                    {service}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="heading-3" style={{ marginBottom: '20px', color: 'var(--bg-primary)' }}>
              Kontak
            </h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              <li className="body-regular" style={{ color: 'var(--text-secondary)', marginBottom: '12px', lineHeight: '1.6' }}>
                {companyInfo.address}
              </li>
              <li className="body-regular" style={{ color: 'var(--text-secondary)', marginBottom: '12px' }}>
                {companyInfo.phone}
              </li>
              <li className="body-regular" style={{ color: 'var(--text-secondary)', marginBottom: '12px' }}>
                {companyInfo.email}
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div style={{
          borderTop: '1px solid var(--border-light)',
          paddingTop: '24px',
          textAlign: 'center'
        }}>
          <p className="body-small" style={{ color: 'var(--text-light)', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', flexWrap: 'wrap' }}>
            © {currentYear} Annisa Wedding. Made with
            <Heart size={16} fill="var(--gold-primary)" color="var(--gold-primary)" />
            in Tasikmalaya, West Java
          </p>
        </div>
      </div>

      <style jsx="true">{`
        .social-icon:hover {
          background: var(--gold-primary) !important;
          transform: translateY(-2px) scale(1.1);
          box-shadow: 0 4px 15px var(--gold-subtle);
        }
        
        .social-icon:hover svg {
          color: #000000 !important;
        }
      `}</style>
    </footer>
  );
};

export default Footer;
